module.exports = __webpack_public_path__ + "static/media/flagBrasil.5df3b4f3.png";